<template>
  <div>
    <NBar title="会员消费记录" :top="true"/>
    <div class="top-bg">
      <div class="user">
        <img class="avatar" :src='userData.avatar ? userData.avatar : require("@/resource/img/device/headImg.png")'/>
        <div class="content-item">
          <div class="user-item">
            <span>{{ userData.nickname || userData.truename }}</span>
            <span style="margin-left: 5px">{{ userData.sex == 1 ? '男' : '女' }}</span>
          </div>
          <span class="code">ID: {{ userData.id }}</span>
        </div>
      </div>
      <div class="data-wrap">
        <div class="item">
          <span class="title">累计消费</span>
          <span class="value">{{ userData.deviceOrderMoney }}</span>
        </div>
        <div class="item">
          <span class="title">累计支付</span>
          <span class="value">{{ userData.deviceOrderMoney }}</span>
        </div>
        <!--        <div class="item">-->
        <!--          <span class="title">累计余额消费</span>-->
        <!--          <span class="value">0</span>-->
        <!--        </div>-->
        <!--        <div class="item">-->
        <!--          <span class="title">累计投币</span>-->
        <!--          <span class="value">0</span>-->
        <!--        </div>-->
      </div>
      <!--      <div class="balance-amount">-->
      <!--        <div class="item">-->
      <!--          <div class="title">-->
      <!--            <img class="balance-img"-->
      <!--                 src="data:image/png;base64,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">-->
      <!--            <span>余币</span>-->
      <!--          </div>-->
      <!--          <div class="balance">-->
      <!--            <span class="price">0</span>-->
      <!--            <span>币</span>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div class="item">-->
      <!--          <div class="title">-->
      <!--            <img class="balance-img"-->
      <!--                 src="data:image/png;base64,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">-->
      <!--            <span>余额</span>-->
      <!--          </div>-->
      <!--          <div class="balance">-->
      <!--            <span class="price">0</span>-->
      <!--            <span>元</span>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <div class="content-div">
      <nut-cell :show-icon="true" title="时间" @click.native="isCalendar = true">
        <span slot="desc" style="color: rgb(0, 122, 255)"><span>{{ date[0] }}</span> 至 <span>{{ date[1] }}</span></span>
      </nut-cell>
      <nut-calendar :is-visible.sync="isCalendar" :default-value="date" type="range"
                    @close="switchPickerClose('isCalendar')" :start-date="null"
                    :end-date="endDate" @choose="setChooseValue">
      </nut-calendar>
      <nut-tab @tab-switch="tabSwitch" :line-width="40">
        <nut-tab-panel tab-title="支付记录">
          <!--          <div class="consume-all-count">支付总额：0.02元</div>-->
          <list-loading ref="list" :data.sync="list" :page.sync="page" :limit.sync="limit" @loadlist="getOrderList"
                        :is-show-mod="true">
            <nut-cell slot="list" v-for="(item,index) in list" :key="index" :show-icon="false" class="item">
              <span slot="title">设备启动</span>
              <span slot="sub-title">{{ item.payTime }}</span>
              <div slot="desc" class="desc">
                <span class="text">{{ item.payMoney }}元</span>
                <span class="price">{{ item.paid == 1 ? '交易成功' : '未成功' }}</span>
              </div>
            </nut-cell>
          </list-loading>
        </nut-tab-panel>
        <nut-tab-panel tab-title="消费记录">
          <list-loading ref="list" :data.sync="list" :page.sync="page" :limit.sync="limit" @loadlist="getOrderList"
                        :is-show-mod="true">
            <div slot="list" v-for="(item,index) in list" :key="index" style="margin-top: 10px">
              <nut-cell :show-icon="false" class="item">
                <span slot="title">消耗金额</span>
                <span slot="sub-title">{{ item.payTime }}</span>
                <div slot="desc" class="desc">
                  <span class="text">{{ item.payMoney }}元</span>
                  <span class="price">{{ item.paid == 1 ? '启动成功' : '未启动' }}</span>
                </div>
              </nut-cell>
              <div class="info-row">
                <span class="title">场地名称</span>
                <span>{{ item.addressName }}</span>
              </div>
              <div class="info-row">
                <span class="title">设备名称</span>
                <span>{{ item.deviceName }}</span>
              </div>
            </div>
          </list-loading>
        </nut-tab-panel>
      </nut-tab>
    </div>
  </div>
</template>

<script>
/**
 * 会员消费记录
 */
export default {
  name: 'MemberDetail',
  props: ['uid'],
  data() {
    return {
      userData: {},
      endDate: this.$util.formatDate.format (new Date (), 'yyyy-MM-dd'),
      list: [],
      page: 1,
      limit: 10,
      //时间选择器区间
      date: [],
      //是否显示时间选择器
      isCalendar: false,
    }
  },
  created() {
    this.date = [this.$util.formatDate.format (new Date (), 'yyyy-MM-dd'), this.$util.formatDate.format (new Date (), 'yyyy-MM-dd')]
  },
  mounted() {
    this.getData ()
    this.getOrderList ()
  },
  methods: {
    tabSwitch: function (index, event) {
    },
    switchPickerClose(param) {
      this[`${param}`] = false
    },
    setChooseValue(param) {
      this.date = [...[param[0][3], param[1][3]]]
      this.isCalendar = false
      this.getOrderList ()
    },
    getData() {
      let data = {
        id: this.uid
      }
      if (!this.$util.isArrOrNull (this.$api.merId)) {
        data.merId = this.$api.merId
      }
      this.$api.post ({
        url: '/device/api/device/device-user/detail',
        data: data
      }).then (res => {
        this.userData = res.data
      })
    },
    getOrderList() {
      let time1 = new Date (this.date[0].replace (/-/g, '/') + ' 00:00:00')
      let time2 = new Date (this.date[1].replace (/-/g, '/') + ' 23:59:59')
      this.$api.post ({
        url: '/device/api/device/order/list',
        data: {
          merId: this.merId,
          uid: this.uid,
          startTime: time1.getTime () / 1000,
          endTime: time2.getTime () / 1000,
          page: this.page,
          limit: this.limit
        },
        loading: false
      }).then (res => {
        this.$refs.list.setRes (res)
      })
    },
  }
}
</script>

<style scoped>
>>> .nut-calendar-control .nut-calendar-cancel-btn, >>> .nut-calendar-control .nut-calendar-confirm-btn {
  color: #1a87ff;
}

>>> .nut-calendar-control .nut-calendar-week span:first-child, >>> .nut-calendar-control .nut-calendar-week span:last-child {
  color: #1a87ff;
}

>>> .nut-calendar-months .nut-calendar-month-con .nut-calendar-month-day-active {
  background-color: #1a87ff;
}

>>> .nut-calendar-months .nut-calendar-month-con .nut-calendar-month-day-choose {
  background-color: #abd1ff;
}

.top-bg {
  padding: 20px 10px 20px 10px;
  background: #43474d;
  margin-bottom: 10px;
  position: fixed;
  width: 100%;
  top: 40px;
  z-index: 100;
}

.top-bg .user {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.top-bg .user .avatar {
  width: 40px;
  height: 40px;
  margin-right: 10px;
  border-radius: 50%;
}

.top-bg .user .content-item {
  display: flex;
  flex-direction: column;
  color: #fff;
}

.top-bg .user .content-item .user-item {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.top-bg .user .content-item .user-item .gender-icon {
  width: 15px;
  height: 15px;
  margin-left: 10px;
}

.top-bg .user .content-item .code {
  color: #aaa;
  margin-top: 5px;
}

.top-bg .data-wrap {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 5px;
}

.top-bg .data-wrap .item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  color: #fff;
}

.top-bg .data-wrap .item .title {
  color: #aaa;
  margin-bottom: 5px;
}

.top-bg .data-wrap .item .value {
  flex: 1;
  font-size: 14px;
}

.top-bg .balance-amount {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 70px;
  background: #fff;
  position: absolute;
  top: 110px;
  right: 55px;
  left: 35px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .1);
  border-radius: 5px;
}

.top-bg .balance-amount .item {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex: 1;
}

.top-bg .balance-amount .title {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.top-bg .balance-amount .title .balance-img {
  width: 18px;
  height: 18px;
  margin-right: 5px;
}

.top-bg .balance-amount .balance {
  margin-top: 5px;
}

.top-bg .balance-amount .balance .price {
  font-size: 20px;
}

.top-bg .balance-amount .item:after {
  content: "";
  display: inline-block;
  width: 1px;
  height: 30px;
  background: #ddd;
  position: absolute;
  top: 10px;
  right: 0;
}

.content-div {
  margin-top: 120px;
}

.content-div .consume-all-count {
  padding: 15px 10px;
  background: #f5f5f5;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999;
}

.content-div .item {
  padding: 5px 10px 0px 10px;
}

.content-div .item .desc {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-right: 5px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
}

.item .desc .text {
  color: #585858;
}

.item .desc .price {
  color: #44b90a;
}

.content-div .info-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px 5px 10px;
  background: #fff;
}

.content-div .info-row .title {
  color: #999;
}

>>> .nut-tab {
  user-select: none;
  padding: 0;
  border-bottom: none;
  border-left: none;
  border-right: none;
}

>>> .nut-tab-title {
  border-bottom: none;
}

>>> .nav-bar {
  background-color: #194fff;
}

>>> .nut-tab-active a {
  color: #194fff;
}

>>> .nut-tab-item {
  padding: 0;
  background-color: #F5F6F8;
  border: none;
}

>>> .nut-tab-panel {
  background: #F5F6F8;
}

</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/member/MemberDetail.vue